module.exports = require("@jswork/react-fade-image");